import { app } from '../../../../../../../bootstrap/core';

import { createRequestAccountswitchDatesComponent } from './accountswitchDates.component';

app.component(
  createRequestAccountswitchDatesComponent.name,
  createRequestAccountswitchDatesComponent,
);
